import axios from "@/axios";
import Util from "@/util/util";
import moment from "moment";

export const namespaced = true;
const defaultData = {
  id: 0,
  isPartial: true,
  // To Local Change of Radio Button
  inspectedReceivedByIsPartialDirty: false,
  receiverName: null,
  receiverUnitOffice: null,
  receiverOrganizationId: null,
  receiverSignature: {
    signatureId: 0,
    type: "TEXT",
    text: null,
    fontFamily: null,
    edit: null,
    view: null,
  },
  receiverSignatureId: 3,
  receiverDateRequested: null,
  receiverDateSigned: null,
  organizations: [],
};

const resetData = {
  type: "TEXT",
  text: null,
  fontFamily: null,
  edit: null,
  view: null,
};

const IMAGE_EXP = /data:image\/[a-z]+;base64,/;

export const state = {
  inspectedReceivedBy: Object.assign({}, defaultData),
  inspectedReceivedByIsPartialDirty: false,
  helper: { countryId: 0, buySell: "" },
  status: false,
  inspectedReceivedByErrors: [],
};

export const getters = {
  inspectedReceivedBy: (state) => state.inspectedReceivedBy,
  inspectedReceivedByStatus: (state) => state.status,
  inspectedReceivedByHelper: (state) => state.helper,
  inspectedReceivedByErrors: (state) => state.inspectedReceivedByErrors
};

export const mutations = {
SET_RECEIVED_API: (state, payload) => {
  const responseData = payload?.data || {};
  const hasOverride = payload && Object.prototype.hasOwnProperty.call(payload, 'isPartialOverride');

  // Normalize booleans (important)
  const toBool = (v) => v === true || v === 'true' || v === 1 || v === '1';

  // Capture current dirty state and value before potentially clearing
  const wasDirty = state.inspectedReceivedByIsPartialDirty;
  const previousIsPartial = state.inspectedReceivedBy?.isPartial;

  // If user changed radio, mark dirty; otherwise preserve dirty state for reloads after save
  if (hasOverride) {
    state.inspectedReceivedByIsPartialDirty = true;
  }
  // Only clear dirty flag on fresh page load (when not dirty before)
  // Don't clear it after save/reload to preserve user's selection

  const apiHasIsPartial =
    responseData.isPartial !== undefined && responseData.isPartial !== null;

  const apiIsPartial = apiHasIsPartial
    ? toBool(responseData.isPartial)
    : undefined;

  // Handling Override logic
  const nextIsPartial =
    hasOverride ? toBool(payload.isPartialOverride) :
    wasDirty ? previousIsPartial :
    apiHasIsPartial ? apiIsPartial : previousIsPartial;

  state.inspectedReceivedBy = Object.assign(
    {},
    state.inspectedReceivedBy,
    responseData,
    {
      isPartial: nextIsPartial,
      receiverSignature: responseData.receiverSignature
        ? responseData.receiverSignature
        : defaultData.receiverSignature
    }
  );

  if (
    state.inspectedReceivedBy.receiverSignature?.edit &&
    !state.inspectedReceivedBy.receiverSignature.edit.match(IMAGE_EXP)
  ) {
    state.inspectedReceivedBy.receiverSignature.edit =
      window.atob(state.inspectedReceivedBy.receiverSignature.edit);
  }

  if (
    state.inspectedReceivedBy.receiverSignature?.view &&
    !state.inspectedReceivedBy.receiverSignature.view.match(IMAGE_EXP)
  ) {
    state.inspectedReceivedBy.receiverSignature.view =
      window.atob(state.inspectedReceivedBy.receiverSignature.view);
  }
},
  SET_RECEIVED_SIG: (state, response) => {
    var receivedSig = Object.assign({}, response.data.receiverSignature ? response.data.receiverSignature : defaultData.receiverSignature);
    
    // Decode if signature has been edited and is not already an image
    if (receivedSig.edit && !receivedSig.edit.match(IMAGE_EXP)) {
      receivedSig.edit = window.atob(receivedSig.edit);
    }
    
    if (receivedSig.view && !receivedSig.view.match(IMAGE_EXP)) {
      receivedSig.view = window.atob(receivedSig.view);
    }

    state.inspectedReceivedBy.receiverSignature = receivedSig;
  },
  SET_RECEIVED_DATA: (state, data) => {
    state.inspectedReceivedBy = Object.assign({}, state.inspectedReceivedBy, data)
  },
  SET_STATUS: (state, value) => (state.status = value),

  SET_HELPER: (state, value) => (state.helper = value),
  CLEAR_DATA: (state) => {
    state.inspectedReceivedBy = defaultData;
    state.inspectedReceivedByIsPartialDirty = false;
  },
  SET_ERRORS: (state, data) => (state.inspectedReceivedByErrors = data),
  CLEAR_ERRORS: (state) => (state.inspectedReceivedByErrors = [])
};

export const actions = {
  clearData({ commit }) {
    commit("CLEAR_DATA");
  },

  async getInspectedReceivedByStatus({ commit }, id) {
    if (id == 0) {
      commit("SET_STATUS", false);
    }
    else {
      return await axios.get(`/api/receivedsignatures/status/${id}`)
        .then(({ data }) => {
          if (data && data.length === 0) {
            commit("SET_STATUS", true);
            commit("CLEAR_ERRORS");
          }
          else {
            commit("SET_STATUS", false);
            commit("SET_ERRORS", data);
          }
        });
    }
  },

  async getInspectedReceivedByHelper({ commit }, id) {
    if (id == 0) {
      commit("SET_HELPER", { countryId: 0, buySell: "" });
    }
    else {
      return await axios.get("/api/signatures/helper/" + id)
        .then(({ data }) => {
          commit("SET_HELPER", data);
        });
    }
  },

  async getInspectedReceivedBy({ commit, state, dispatch }, orderId) {
    try {
      
      const response  =  await axios.get(`/api/receivedsignatures/${orderId}`)
      commit("SET_RECEIVED_API",{ data: response.data, force: true } );
    }
    catch (error) {
      console.log("ERROR LOADING RECEIVED INFORMATION: ", error); //not handelled
    }
  },

  async getInspectedReceivedBySigOnly({ commit, state, dispatch }, orderId) {
    try {
      commit("SET_RECEIVED_SIG", await axios.get(`/api/receivedsignatures/${orderId}`));
    }
    catch (error) {
      console.log("ERROR LOADING RECEIVED INFORMATION: ", error); //not handelled
    }
  },

  getCacSignature({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/signatures/certificatename")
        .then(function (response) {
          const cacSignature = "data:image/jpg;base64," + response.data;
          dispatch("setSignature", cacSignature);
          return resolve();
        })
        .catch(function (error) {
          return reject(`There was an error getting the CAC signature... ${error.response.data}`);
        });
    });
  },

  setSignature({ commit, state }, signature) {
    let date = null;

    // Don't auto-set date for UPLOAD type — backend handles signature dates
    if (!Util.isNullOrEmpty(signature) && signature.type !== "UPLOAD") {
      date = Util.convertToDateTime(moment.utc().format("MM-DD-y HH:mm:ss"));
    }

    commit("SET_RECEIVED_DATA", { receiverSignature: Object.assign({}, state.inspectedReceivedBy.receiverSignature, signature), receiverDateSigned: date });
  },

  async getOrganizations({ commit, state }, params) {
    try {
      let response = []

      if (params.buySell === "BUY") {

        response = await axios.get("/api/organizations/countrycode/US");

        let organizationId = (response && response.data) ? state.inspectedReceivedBy.receiverOrganizationId : null

        commit("SET_RECEIVED_DATA", { organizations: response.data, receiverOrganizationId: organizationId });
      }

      else if (params.buySell === "SELL" && params.countryId) {

        response = await axios.get(`/api/organizations/countryid/${params.countryId}`);

        let organizationId = (response && response.data) ? state.inspectedReceivedBy.receiverOrganizationId : null

        commit("SET_RECEIVED_DATA", { organizations: response.data, receiverOrganizationId: organizationId });
      }

      let found = response.data.find(item => item.id === state.inspectedReceivedBy.receiverOrganizationId);

      if (params.preOrderDetailStatus && params.agreementInformationStatus && !found) {
        commit("SET_RECEIVED_DATA", { receiverOrganizationId: null });
      }
    }
    catch (error) {
      commit("SET_RECEIVED_DATA", { receiverOrganizationId: null, organizations: [] });
    }
  },

  saveInspectedReceivedBy({ commit, state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      let received = Object.assign({}, state.inspectedReceivedBy, {
        receiverSignature: (!state.inspectedReceivedBy.receiverSignature.view) ? null :
          {
            ...state.inspectedReceivedBy.receiverSignature,
            edit: (state.inspectedReceivedBy.receiverSignature.edit) ? window.btoa(state.inspectedReceivedBy.receiverSignature.edit) : "",
            view: (state.inspectedReceivedBy.receiverSignature.view) ? window.btoa(state.inspectedReceivedBy.receiverSignature.view) : "",
          },
        receiverDateSigned: Util.convertToDateTime(state.inspectedReceivedBy.receiverDateSigned),
        pin: (state.inspectedReceivedBy.receiverSignature.view) ? data.pin : null 
      });
      axios.post("/api/receivedsignatures", received, { config: { showToast: false } })
        .then(function (response) {
          return dispatch("getInspectedReceivedBy", data.orderId);
        })
        .then(function () {
          return resolve();
        })
        .catch(function (error) {
          return reject(`There was an error saving Received to the server...  ${error.response.data}`);
        });
    });
  },
};
